export async function Sleep(milliseconds: number): Promise<void> {
    await new Promise(r => setTimeout(r, milliseconds));
}
